<script>
  import { completeDiscordOAuth } from '../../lib/stores/auth.svelte.js';

  let { code, oauthState } = $props();

  let error = $state('');
  let loading = $state(true);

  $effect(() => {
    if (code && oauthState) {
      handleCallback();
    } else {
      error = 'Invalid callback URL. Missing authorization code.';
      loading = false;
    }
  });

  async function handleCallback() {
    loading = true;
    error = '';
    try {
      const result = await completeDiscordOAuth(code, oauthState);
      console.log('[DiscordCallback] Sign-in complete, navigating to:', result.returnPath);
      // Use full navigation to trigger route parsing with fresh auth state
      window.location.replace(result.returnPath);
    } catch (err) {
      error = err.message || 'Discord sign-in failed. Please try again.';
      console.error('[DiscordCallback] Error:', err);
      loading = false;
    }
  }
</script>

<main class="callback-page">
  <div class="callback-container">
    {#if loading}
      <div class="callback-card">
        <div class="callback-spinner"></div>
        <h1 class="callback-title">Signing in with Discord...</h1>
        <p class="callback-subtitle">Please wait while we complete your sign-in.</p>
      </div>
    {:else if error}
      <div class="callback-card error-card">
        <div class="callback-icon">!</div>
        <h1 class="callback-title">Sign-in Failed</h1>
        <p class="callback-subtitle">{error}</p>
        <button class="btn-primary" onclick={() => (window.location.href = '/')}>Go Home</button>
      </div>
    {/if}
  </div>
</main>

<style>
  .callback-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 16px;
  }

  .callback-container {
    width: 100%;
    max-width: 400px;
  }

  .callback-card {
    background: white;
    border-radius: 20px;
    padding: 40px 32px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .callback-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #e5e7eb;
    border-top-color: #5865f2;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .callback-icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #fef2f2;
    color: #ef4444;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    font-weight: 700;
  }

  .callback-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1f2937;
    margin: 0;
  }

  .callback-subtitle {
    font-size: 15px;
    color: #6b7280;
    margin: 0;
    line-height: 1.5;
  }

  .btn-primary {
    padding: 12px 24px;
    background: #3b82f6;
    color: white;
    border: none;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;
    font-family: inherit;
  }

  .btn-primary:hover {
    background: #2563eb;
  }

  .error-card {
    border: 1px solid #fecaca;
  }
</style>
